import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=1792d338&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"
import style0 from "./badge.vue?vue&type=style&index=0&id=1792d338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792d338",
  null
  
)

export default component.exports